import { render } from "./FullCalendarWrapper.vue?vue&type=template&id=25eff3ee&ts=true"
import script from "./FullCalendarWrapper.vue?vue&type=script&lang=ts"
export * from "./FullCalendarWrapper.vue?vue&type=script&lang=ts"

import "./FullCalendarWrapper.vue?vue&type=style&index=0&id=25eff3ee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__